import React, { useContext } from 'react'
import { navigate } from 'gatsby'

import gotasCaja from '../../../assets/images/gotasCaja.png'
import iconFlechas from '../../../assets/images/iconFlechas.png'
import logoActividad from '../../../assets/images/logoActividad.png'
import iconToalla from '../../../assets/images/toalla.png'
import iconMujer from '../../../assets/images/iconoMujerHome.png'
import premio from '../../../assets/images/premioHome.png'

import pushEventDataLayer from '../../../utils/pushEventDataLayer'

import { Context } from '../../../context/app-context'

import Button from '../../atoms/button/button'

import './bannerSection.scss'
import { topNumber } from '../../../constants/activity-constants'

const BannerSection = ({ isMobile }) => {
  const { dispatch } = useContext(Context)

  return (
    <div className="f-bannerSection-container">
      <div className="f-bannerSection-container__wrapper">
        <div className="f-bannerSection-container__colum1">
          <img
            className="f-bannerSection-container__colum1__imgGotasCaja"
            src={gotasCaja}
            alt="demostracion grafica juego"
          />
          <img
            className="f-bannerSection-container__colum1__imgIconFlechas"
            src={iconFlechas}
            alt="icono de flechas"
          />
          <figure className="f-bannerSection-container__colum1__cuadroTexto">
            <p>
              Derribá las gotas de sangre, descubrí las cajas mágicas y poné a
              prueba tu conocimiento.
            </p>
          </figure>
        </div>
        <div className="f-bannerSection-container__colum2">
          <img
            src={logoActividad}
            className="f-bannerSection-container__colum2__imgLogoActividad"
            alt="demostracion del icono de la actividad"
          />
          <h2>¡Divertite y ganá premios con la nueva tecnología Cur-V!</h2>
          <img
            src={iconToalla}
            className="f-bannerSection-container__colum2__imgIconToalla"
            alt="toalla nosotras cur-v"
          />
          <h2>¿Estás lista para jugar?</h2>
          <Button
            title="JUGAR"
            size="f-large"
            color="f-gradient-pink"
            props="mt-30"
            onClick={() => {
              pushEventDataLayer(
                'Interacciones - Jugar',
                'cur-v-shooter',
                'click juego',
                'jugar'
              )
              navigate('/jugar')
            }}
          />
        </div>
        <div className="f-bannerSection-container__colum3">
          <figure className="f-bannerSection-container__colum3__top">
            <h2>Jugá las veces que querás</h2>
            {!isMobile && <img src={iconMujer} alt="mujer en celular feliz" />}
          </figure>
          <figure className="f-bannerSection-container__colum3__bot">
            <img src={premio} alt="premio de la actividad" />
            <p>
              Si sos una de las <span>{topNumber} ganadoras,</span> podrás ganar
              un fabuloso Kit con merchandising y productos Nosotras
            </p>
          </figure>
        </div>
      </div>
    </div>
  )
}

export default BannerSection
